import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';

/** Body only — for use inside an area shell, which already owns the <main> landmark. */
export function NotFoundSection() {
  const { t } = useTranslation();

  return (
    <div className="text-center">
      <p className="text-sm font-semibold uppercase tracking-wide text-accent-foreground">{t('notFound.code')}</p>
      <h1 className="mt-3 text-4xl font-heading font-semibold tracking-normal text-foreground">{t('notFound.title')}</h1>
      <p className="mx-auto mt-4 max-w-md text-muted-foreground">{t('notFound.description')}</p>
      <a
        href="/"
        className="mt-8 inline-flex items-center justify-center gap-2 rounded bg-primary px-4 py-2 text-sm font-semibold text-primary-foreground ring-1 ring-primary-hover transition hover:bg-primary-hover focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring disabled:cursor-not-allowed disabled:opacity-60"
      >
        <ArrowLeftIcon className="size-4" aria-hidden="true" />
        {t('notFound.backHome')}
      </a>
    </div>
  );
}

export function NotFoundPage() {
  return (
    <main className="grid min-h-screen place-items-center bg-background px-5 text-foreground">
      <NotFoundSection />
    </main>
  );
}
